import React from "react";
import "../style/Explore.css";

import { BsGlobe } from "react-icons/bs";
import { AiOutlineTwitter } from "react-icons/ai";
import { FaDiscord } from "react-icons/fa";
import { BiLinkExternal } from "react-icons/bi";

function Explore() {
  return (
    <section>
      <div className="mainContainer pt-md-5 pt-3">
        <div className="textContainer ">
          <div className="landingDescription">
            <div className="exploreText">
              <h2>The Swoop Genesis Collection</h2>
              <div className="doxxedRow">
                <a className="doxxed">Doxxed</a>
                <a className="doxxed">Escrow</a>
                <div className="price">Price 2.50</div>
                <div className="iconClass">
                  <AiOutlineTwitter />
                </div>
                <div className="iconClass">
                  <FaDiscord />{" "}
                </div>
                <div className="iconClass">
                  <BsGlobe />
                </div>
              </div>
              <div>
                <p className="para">
                  The Genesis Collection - Cricket NFTs to collect, trade and
                  utilize on Swoop. Now, apart from getting lost in the drama of
                  Cricket, own a piece of the action
                </p>
              </div>
            </div>
            <div className="exploreImg">
              <img src="image 7.png" alt="img" className="" />
            </div>
          </div>
          <div className="swoopCollection">
            <div className="col-lg-6">
              <h2>The Swoop Genesis Collection</h2>
              <div className="pt-sm-4 pt-2 d-flex gap-2 flex-wrap">
                <div className="externalLink">
                  <a href="#">
                    <BiLinkExternal /> Whitepaper{" "}
                  </a>
                </div>
                <div className="externalLink">
                  <a href="#">
                    <BiLinkExternal /> website{" "}
                  </a>
                </div>
                <div className="externalLink">
                  <a href="#">
                    <BiLinkExternal /> Twitter{" "}
                  </a>
                </div>
                <div className="externalLink">
                  <a href="#">
                    <BiLinkExternal /> Discord{" "}
                  </a>
                </div>
              </div>
              <div className="leftdisc">
                <p>
                  The big bang is happening again. Life forms have been living
                  in peace on Earth, but it took one stoner to screw it all up.
                  The end of the world button has unfortunately been pushed.
                </p>
                <p>
                  5,555 unconventional voyagers traveling through an innovative
                  Web3 entertainment experience with real world travel benefits.
                  An extraordinary vision implemented by an ordinary group of
                  full time Web3 friends.
                </p>
                <p>
                  2105’ first goal is to create an emotional connection between
                  individuals within the space. To do so, the 2105 team is
                  building an inner and outer $BOOZE ecosystem. One that has
                  plenty of use cases and benefits that appeal to each and every
                  single member.
                </p>
                <p>
                  Ensuring an everlasting circular economy that is perfectly
                  sustainable for all Voyagers to give and receive. Together, we
                  are set to make history and leave our everlasting vibes on the
                  canvas of galactic space.
                </p>
              </div>
            </div>
            <div className="col-lg-6 rightDisc">
              <div className="d-flex gap-3">
                <div className="artistTeam borderGreen">artists</div>
                <div className="artistTeam">Team</div>
              </div>
              <p>
                Following a roadmap tends to lead to unnecessary friction while
                the community and project move forward. The list below
                summarizes what we're working on here and now. Keep in mind that
                this is bound to evolve over time for the better.
              </p>
              <label>Voyagers Travel Club & Brand Partnerships</label>
              <p>
                A key mission of ours is to establish Voyagers as THE travel
                community on Solana and web3. We will partner with crypto
                friendly travel brands looking to market to our large, highly
                engaged audience.
              </p>
              <p>
                Benefits for 2105' community members for travel & leisure
                collaborations are far and wide. Examples include raffles to win
                holidays on the Booze market, discount codes to holders, bulk
                buying discounts to leisure events across the globe. The
                possibilities are infinite.
              </p>
              <label>Booze economy</label>
              <p>
                Staking your Voyagers will be rewarded with 2105' native token
                aka $BOOZE which comes with plenty of utilities.
              </p>
              <p>
                Shopping on Booze Market (Travel packages, discount / coupon
                codes, WL, NFT, Merchs...).
              </p>
              <p>
                Playing Conquest / Minting Conquest' lootbox, resources or
                items.
              </p>
              <p>Trading it for $SOL</p>
              <label>Conquest</label>
              <p>
                Conquest is 2105' blockchain browser-based idle game where you
                manage planets and create space-ships in order to conquer the
                entire galaxy.
              </p>
              <label>Storytelling</label>
              <p>
                While 2105 is starting off as the Voyagers collection, it is
                growing into so much more. With our Comic’s pilot, we are
                focusing heavily on developing our unique lore, where stoners
                movies meet space opera. We also plan to tell you the Voyagers
                story through Conquest, Discord and diverse events.
              </p>
              <label>Community first</label>
              <p>
                High end DAO experience with a dedicated team of researchers and
                moderators, you will be in good hands to get the most out of
                your Solana trip. 2105' discord will host a multi-goal oriented
                one-month program that helps Web3 newcomers. The first program
                is designed for those who wish to become NFTs collectors. The
                second program is for creators/ artists.
              </p>
              <label>Commitment framework</label>
              <p>
                2105’s DAO is fueled by our decentralized collaboration
                framework. Long story short, anyone can contribute and be
                rewarded smoothly. Your weight in the DAO will be mostly
                determined by the number of Voyagers NFTs you hold. This will
                impact your chance to win raffles, your weight in polls and
                more.
              </p>
              <label>Brand awareness</label>
              <p>
                Increase authority, being different from the other brands,
                that's 2105' goal. We plan to do it through our several
                communications channels discussed below. Our long term plan
                includes developing an incubator program for those who wish to
                build upon $BOOZE.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Explore;
